export default __webpack_public_path__ + "static/media/IMG_4220_edited.f1f347b9.jpg";